<template>
  <section-container>
    <div class="w-full flex justify-center items-center flex-wrap p-2">
      <div class="w-full lg:w-1/2 flex flex-wrap flex-col">
        <h3 class="text-2xl font-bold mb-5">Sua Loja</h3>
        <store-card
          :store_title="store.name"
          :id="store.id"
          v-on:store_deleted="doDeleteStore"
          :slug="store.slug"
        ></store-card>
      </div>
      <div class="w-full lg:w-1/2 flex justify-center items-center px-4">
        <img
          src="@/assets/img/stores.png"
          alt=""
          width="650px"
          class="h-auto overflow-hidden"
        />
      </div>
    </div>
    <content-e>
      <div class="w-full p-2 bg-white shadow-2l rounded-lg">teste</div>
    </content-e>
  </section-container>
</template>

<script>
import StoreCard from '@/components/Store/StoreCard'
export default {
  components: {
    StoreCard
  },
  data() {
    return {
      store: null
    }
  },
  methods: {
    doStore() {
      this.$store.dispatch('store/MY_STORES').then((response) => {
        this.store = response.data.data
      })
    }
  },
  beforeMount() {
    this.doStore()
  }
}
</script>

<style>
</style>
